import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { t } from "i18next";
import { Notification } from "../../interface/user";
import React, { FC } from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { NOTIFICATION_METHOD_DROPDOWN } from "../../utils/dropdown/notification";
import { setNotificationSetting } from "../../api/user";
export const NotificationPage: FC<{ data?: Notification[] }> = ({
	data = [],
}) => {
	const handleNotificationMethodChange = (data: {
		notificationMethodId: string;
		notificationEventId: string;
	}) => {
		setNotificationSetting(data)
			.then((res) => {
				console.log("Notification setting updated", res);
			})
			.catch((err) => {
				console.error("Error updating notification setting", err);
			});
	};

	const CustomCell = (props: any) => {
		return (
			<td style={{ textAlign: "center" }}>
				<DropDownList
					style={{ width: "100%" }}
					data={NOTIFICATION_METHOD_DROPDOWN}
					dataItemKey="id"
					textField="name"
					value={{
						id: props.notificationMethod.id,
						name: t(props.notificationMethod.name),
					}}
					onChange={(e) =>
						handleNotificationMethodChange({
							notificationMethodId: e.target.value.id,
							notificationEventId: props.id,
						})
					}
					popupSettings={{ width: "auto" }}
				/>
			</td>
		);
	};

	return (
		<div style={{ height: "100%", borderTop: "1px solid #dee2e6" }}>
			<Grid
				style={{ overflowY: "hidden" }}
				data={data}
				className="hide-virtual-scroll"
			>
				<GridColumn field="event" title={t("Incident")} />
				<GridColumn field="description" title={t("Description")} />
				<GridColumn
					field="notificationMethod.id"
					title={t("Method")}
					width="150px"
					cells={{
						data: (prop) => <CustomCell {...prop.dataItem} />,
					}}
				/>
			</Grid>
		</div>
	);
};
